import React from "react";
import { useRef, useCallback } from "react";

import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";

const plugin = {
  id: "customCanvasBackgroundColor",
  beforeDraw: (chart, args, options) => {
    const { ctx } = chart;
    ctx.save();
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle = options.color || "#fff";
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  },
};

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  plugin
);

export const data = {
  labels: [
    "A1.1 Legal and administrative requirements",
    "A1.2 Professional responsibility",
    "A1.3 Ethical principles",
    "A1.4 Guidance relationship",
    "A2.1 Theoretical knowledge",
    "A2.2 Applying theoretical knowledge",
    "A2.3 Research in the field of guidance",
    "A3.1 Reflective professional practice",
    "A3.2 Developing personal competency",
    "A4.1 Clear communication",
    "A4.2 Goal-oriented interaction",
    "A4.3 Reflexive communication",
    "A4.4 Professional communication",
    "A5.1 Technology in guidance",
    "A5.2 Technology in the guidance process",
    "A5.3 Collaborative use of technology",
    "A5.4 Systematic development of using technology in guidance",
    "B1.1 Features of the guidance process",
    "B1.2 Guidance as a process",
    "B1.3 Outcomes and impact of the guidance process",
    "B2.1 Developmental and life span theories",
    "B2.2 Career development theories",
    "B2.3 Society and working life",
    "B2.4 Guidance theories",
    "B2.5 Lifelong and continuous learning",
    "B2.6 Guidance philosophy",
    "B3.1 Information retrieval and management",
    "B3.2 Reflecting and setting goals",
    "B3.3 Client-centered guidance process",
    "B3.4 Evaluation",
    "C1.1 Guidance in society",
    "C1.2 Lifelong nature of guidance",
    "C1.3 Position and positioning guidance",
    "C2.1 Organisations and networks",
    "C2.2 Strategic learning",
    "C3.1 Multiprofessional networking",
    "C3.2 Multisectoral networking",
    "C4.1 Planning and organisation",
    "C4.2 Quality assessment and monitoring",
    "C4.3 Continuous development",
  ],
};

const options = {
  plugins: [plugin],
  scales: {
    r: {
      pointLabels: {
        callback: function (label, index) {
          if (label === "A1.1 Legal and administrative requirements") {
            return "A1.1 Legal and...";
          } else if (label === "B2.1 Developmental and life span theories") {
            return "B2.1 Developmental and...";
          } else {
            return label;
          }
        },
      },
      ticks: {
        font: {
          size: 16,
          weight: "bold",
        },
      },
    },
  },
  scale: {
    min: 0,
    max: 3,
    ticks: {
      beginAtZero: true,
      max: 3,
      min: 0,
      stepSize: 1,
    },
  },
};

export function RadarElement({ values, competenceGoalsState }) {
  let ref = useRef(null);

  const downloadImage = useCallback(() => {
    const link = document.createElement("a");
    link.download = "competency_map.jpeg";
    link.href = ref.current.toBase64Image("image/jpeg", 1);
    link.click();
  }, []);
  if (!values.present.includes(null)) {
    data.datasets = [
      {
        label: "current competency level",
        data: values.present,
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ];
  }
  if (!values.goal.includes(null)) {
    data.datasets = [
      ...data.datasets,
      {
        label: "Goal",
        data: values.goal,
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgb(54, 162, 235)",
        pointBackgroundColor: "rgb(54, 162, 235)",
        borderWidth: 1,
      },
    ];
  }

  return (
    <div>
      <p className="content-area">
        Download an image of your competency map&nbsp; 
        <button type="button" className="link-button" onClick={downloadImage}>
           here
        </button>
        .
      </p>
      <Radar ref={ref} data={data} options={options} />
    </div>
  );
}
